module.exports = __webpack_public_path__ + "static/media/try-another-way.5084c287.svg";